export default "__VITE_ASSET__e9411579__"